import angular from 'angular';
import uiRouter from 'angular-ui-router';
import ResponseComponent from './response.component';
import routing from './response.routes';

export default angular
  .module('verifyApp.public.case.response', [uiRouter])
  .config(routing)
  .component('response', ResponseComponent)
  .name;



// WEBPACK FOOTER //
// ./client/app/public/case/response/index.js